import React from 'react'
import gourmet from '../images/gourmet2.svg'
import celebration from '../images/celebration2.svg'
import ogImage from '../images/ogImage.png';
import { BsSearchHeart } from "react-icons/bs";

import { motion, AnimatePresence } from "framer-motion"
const Hero = ({isEng, highlights, isFood, handleSearch,searchFoodObject, setSearchFoodObjectHandler, setSearchDrinkObjectHandler,searchDrinkObject }) => {
 
  let highlight
  if(highlights){
      highlight  = highlights[0]
      
  }
   
  return (
    <div className='relative m-[2px] rounded-md h-[70px] bg-mainOne  text-center italic p-1 leading-[1rem]  text-mainTwo'>
      {isFood &&
        (
          <div>
            <img className='hidden' alt="showcase" src={ogImage} /> 
            <motion.div  
            onClick={handleSearch}
            animate={{y: 15}}
            whileTap={{rotate: 360}}
            transition={{type:"spring"}}
            className='absolute top-1 left-3 w-[70px]h-full'>
            <BsSearchHeart  
            onClick={(e)=>{
              if(searchFoodObject !== ''){
                setSearchFoodObjectHandler('')
              }
            }}
            size={35}/>
            </motion.div>
            
            <motion.img
                  inital={{scale:0}}
                  animate={{scale:1.2, rotate:15}}            
            className='absolute -top-7 w-[130px] -right-10 z-1 ' src={gourmet} />
            <h1 className='m-1 text-base font-bold'>{!isEng ? highlight?.highlight1 : highlight?.highlight1_eng}</h1>
            <p className='text-base'>{!isEng ? highlight?.highlight2 : highlight?.highlight2_eng}</p>
          </div>
        ) }
        {!isFood && 
        (
          <div className=''>
             <img className='hidden' alt="showcase" src={ogImage} /> 
            <motion.div  
            onClick={handleSearch}
            animate={{y: 15}}
            whileTap={{rotate: 360}}
            transition={{type:"spring"}}
            className='absolute top-1 left-3 w-[70px] h-full'>
            <BsSearchHeart  
            onClick={(e)=>{
              if(searchDrinkObject !== ''){
                setSearchDrinkObjectHandler('')
              }
            }}
            size={35}/>
            </motion.div>
            <motion.img inital={{scale:0}}
                  animate={{scale:1.1, rotate:-15}}     className='absolute -top-5 w-[140px] -right-12 ' src={celebration} />
            <h1 className='m-2 text-base font-bold '>{!isEng ? highlight?.highlight1_drinks : highlight?.highlight1_drinks_eng}</h1>
            <p className='text-base'>{!isEng ?  highlight?.highlight2_drinks : highlight?.highlight2_drinks_eng}</p>
          </div>
        )}

    </div>
  )
}

export default Hero